import _SegmentationUtil from './../_SegmentationUtil';

export default [() => {
    return {
        restrict: 'EA',
        controller: ['$element', '$q', 'queryParamsData', function ($element, $q, queryParamsData) {
            return _SegmentationUtil($element, $q.resolve(queryParamsData));
        }]
    };
}];